import { Item } from "@common/utils/helpers/buildDocItem";
import React from "react";

interface ContentBoxItemProps {
  item: Item;
  index: number;
  showFieldOnlyFirst?: boolean;
}

export const ContentBoxItem: React.FC<ContentBoxItemProps> = ({ item, index, showFieldOnlyFirst = true }) => {
  const { field, state, value, extra } = item;

  const truncateText = (text: string, maxLength: number = 35) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className="item">
      <div className="item-row">
        {showFieldOnlyFirst ?
          (index === 0 ? <div className="field">{truncateText(field)}</div> : <div className="field"></div>)
          :
          <div className="field">{truncateText(field)}</div>
        }
        <div className="field">{state}</div>
        <div className="value">{value}</div>
      </div>
      {extra && (
        <div className="item-row extra">
          <div className="field">{extra.field}</div>
          <div className="value">{extra.value}</div>
        </div>
      )}
    </div>
  );
};